/* eslint-disable no-unused-vars */
import { ReportsHeader, ReportsTable, ReportsChart } from 'components';
import { useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { publisherReportsFiltersTableActions } from 'store/actions';
import { isPublisherRole } from 'store/selectors';
import { useComputed, useSignal, useSignalEffect } from '@preact/signals-react';

const useRerender = () => {
  const [, setState] = useState(0);
  return useCallback(() => setState((state) => state + 1), []);
};

const STORAGE_KEY = '___locache___/reports';
const DEFAULT_REQUEST_TYPE = 'applications';

const getLocalStorageItem = ({ key, field, initialValue }) => {
  try {
    const item = window.localStorage.getItem(key);
    if (JSON.parse(item)?.[field]) {
      return JSON.parse(item)?.[field];
    }
  } catch (error) {
    console.error(error);
  }
  return '';
};

export function PublisherReports() {
  const isPublisher = useSelector(isPublisherRole);
  const rerender = useRerender();

  const savedRequestType =
    getLocalStorageItem({ key: STORAGE_KEY, field: 'requestType' }) || DEFAULT_REQUEST_TYPE;
  const currentRequestType$ = useSignal(savedRequestType);

  const selectedAppsNumbers = useSelector(
    (state) => state.publisherReportsFiltersTable.selectedApps,
  );

  const selectedAppsNumbersSet$ = useSignal(new Set(selectedAppsNumbers));
  const selectedAppsNumbers$ = useSignal([...selectedAppsNumbersSet$.value.values()]);
  const dispatch = useDispatch();

  const appNumberIsSelected = useCallback(
    (pba_number) => {
      const res = selectedAppsNumbersSet$.value.has(pba_number);
      return res;
    },
    [selectedAppsNumbersSet$.value],
  );

  const toggleSelectedAppNumber = useCallback(
    (...stateItems) => {
      stateItems.forEach((stateItem) => {
        if (appNumberIsSelected(stateItem)) {
          selectedAppsNumbersSet$.value.delete(stateItem);
        } else {
          selectedAppsNumbersSet$.value.add(stateItem);
        }
        selectedAppsNumbers$.value = [...selectedAppsNumbersSet$.value.values()];
        dispatch(
          publisherReportsFiltersTableActions.updateProperty({
            newValue: selectedAppsNumbers$.value,
            propField: 'selectedApps',
          }),
        );
      });
      rerender();
    },
    [appNumberIsSelected],
  );

  // if (!isPublisher) {
  //   return <div>Sorry, You are not a publisher.</div>;
  // }
  return (
    <>
      <ReportsHeader />
      <ReportsChart />
      <ReportsTable
        currentRequestType$={currentRequestType$}
        appNumberIsSelected={appNumberIsSelected}
        toggleSelectedAppNumber={toggleSelectedAppNumber}
        selectedAppsNumbers$={selectedAppsNumbers$}
      />
    </>
  );
}
